let fileUpload = function () {
    const fileName = $(this).val().replace(/^.*\\/, "");
    $(this).next('.custom-file-label').addClass('selected').html(fileName);
};

$(document).ready(function () {
    return $(document).on('change', '.custom-file-input', fileUpload);
});